const Home = () => {
    return (
        <>
            <div className="bg-blue-500 text-white p-4 rounded-lg shadow-lg">
                <h1 className="text-2xl font-bold">Hello!</h1>
                <p className="mt-2">This is a React app styled.</p>
            </div>
        </>
    )
};

export default Home;
